import { fr } from 'vuetify/es5/locale';

export default {
    ...fr,
    registration: {
        title: 'Inscription',
        submit: 'Continuer',
        join: 'Participer',
        accept_terms_1: 'Nous traitons vos données personnelles. Lisez dans notre ',
        accept_terms_2: 'politique de confidentialité',
        accept_terms_3: ' comment nous procédons.',
        thanks: 'Merci pour votre inscription !',
        watch: 'Aller à l’événement',
        watch_pwa: 'Ouvrir l’application web',
        personal_link_advice: 'Ceci est votre lien personnel. Ne partagez pas ce lien et ne transférez pas cet e-mail.',
        add_to_calendar: 'Ajouter au calendrier',
        loading: 'Chargement...',
        speakers: 'Intervenants',
        sponsors: 'Sponsors',
        confirmation_title: 'Inscription terminée.',
        simplesession_access: 'Pour plus d’informations, vous pouvez accéder à l’événement.',
        multisession_access: 'Pour plus d’informations ou pour modifier les salles de répartition, accédez à l’événement.',
        pwa_access: 'Ouvrez dès maintenant l’application web pour participer à l’interaction pendant l’événement.',
        event_full: 'Cette session est actuellement complète',
        cannot_register_start: 'Vous ne pouvez malheureusement pas vous inscrire à ',
        cannot_register_end_singular: 'L’événement est complet.',
        cannot_register_end_plural: 'Ces événements sont complets.',
        view_online: 'Je participerai à l’événement en ligne',
        view_offline: 'Je participerai à l’événement sur place',
        seats_remaining: 'Il reste {$x} places disponibles',
        one_seat_remaining: 'Il reste 1 place disponible',
        unregister: 'Se désinscrire',
        unregistered: 'Vous vous êtes désinscrit avec succès.',
        unregister_title: 'Se désinscrire de cet événement.',
        already_unregistered: 'Vous êtes déjà désinscrit de cet événement.',
        change_attendance_title_online: 'Modifier la participation en ligne',
        change_attendance_title_on_site: 'Modifier la participation sur place | {$x} places disponibles',
        change_attendance_title_on_site_one_seat: 'Modifier la participation sur place | 1 place disponible',
        change_attendance_button: 'Modifier la participation',
        change_attendance_information: 'Vous recevrez un nouvel e-mail de confirmation avec les informations de l’événement.',
        attendance_changed_to_online: 'Participation modifiée en : en ligne.',
        attendance_changed_to_on_site: 'Participation modifiée en : sur place.',
        agreement: 'J’accepte que mes données personnelles soient supprimées et que je n’aie plus accès à l’événement.',
    },
    agenda: {
        program: 'Programme',
        breakout_round: 'Session en sous-groupes',
        comingUpNext: 'À venir',
    },
    evaluation: {
        submit: 'Envoyer',
        resubmit: 'Mettre à jour votre réponse',
        processing: 'Un instant, votre évaluation est en cours d’envoi...',
        thanks: 'L’évaluation a été envoyée. Merci pour votre participation !',
        you_can_leave: 'Vous pouvez maintenant fermer cet écran.',
        you_can_leave_pwa: 'Cet écran va maintenant se fermer automatiquement.',
    },
    splash: {
        test: 'Testez votre audio et vidéo'
    },
    test: {
        title: 'Tester l’image et le son',
        video_url: 'https://s3.eu-west-1.amazonaws.com/video.quadia.net/public/622b17bc1fd3c9184f796144/18d1a970-e313-473d-8a84-b5044eb28951-hls.m3u8',
        content: '<p>Pas de son ? Vérifiez si le son de la vidéo est coupé. L’icône du volume en bas à gauche contient alors une croix. Cliquez à nouveau pour activer le son. Vous avez encore une question ? Consultez notre <a href="#support">page d’assistance</a>.</p>'
    },
    event: {
        LIVE: 'EN DIRECT',
        ask_a_question: 'Poser une question',
        poll: 'Sondage',
        no_poll: 'Les questions du sondage apparaîtront ici',
        chat: 'Chat',
        evaluation_button: 'Formulaire d’évaluation',
        unmute_text: 'Activer le son',
        quiz: 'Quiz',
        no_quiz: 'Les questions du quiz apparaîtront ici',
        info: 'Infos',
        handout: 'Document',
        home: 'Accueil',
        polls: 'Questions de sondage',
        evaluation: 'Évaluation',
        download_handout_question: 'Êtes-vous sûr de vouloir continuer le téléchargement ?',
        download_handout_title: 'Télécharger le document',
        cancel_download: 'Annuler',
        proceed_download: 'Continuer',
        poll_feedback: 'Votre réponse a été enregistrée.',
        question_submitted: 'Votre question a été envoyée.',
        question_message_placeholder: 'Écrivez votre message ici',
        approval_number: 'Numéro d’approbation',
        sponsor: 'sponsor',
    },
    countdown: {
        text: 'Nous commençons dans',
        days: 'jours',
        hours: 'heures',
        minutes: 'minutes',
        seconds: 'secondes',
        is_about_to_start: 'Nous commençons dans quelques instants. Vous serez redirigé automatiquement.',
        now: 'Cet événement a déjà commencé.',
        ended: 'Cet événement est terminé',
    },
    layout: {
        support: 'Assistance'
    },
    fields: {//registration & evaluation
        choose_answer: 'Choisissez une réponse',
        enter_answer: 'Entrez une réponse',
        validation: {
            required: 'Champ obligatoire',
            required_checkbox: 'Au moins un élément doit être sélectionné',
            notEmail: 'Adresse e-mail invalide',
            notPhoneNumber: 'Numéro de téléphone invalide',
            fixedLength: 'Ce champ doit contenir {length} caractères',
            notANumber: 'Ce champ doit être un nombre entier positif',
            notBetween: 'Ce champ doit être compris entre {min} et {max}',
        },
        mobile_text: 'pour un rappel unique'
    },
    supportModal: {
        title: 'Questions fréquentes',
        sound: {
            title: 'Son',
            question_1: 'Je n’entends aucun son',
            answer_1: 'Avant nos diffusions, de la musique est jouée. Cela vous permet de régler le volume de vos haut-parleurs.',
            answer_1_subq_1: 'Haut-parleurs externes',
            answer_1_suba_1: 'Si vous utilisez des haut-parleurs externes, assurez-vous qu’ils soient correctement connectés.',
            answer_1_subq_2: 'Paramètres du flux',
            answer_1_suba_2: 'Votre navigateur a peut-être automatiquement coupé le son. Vous pouvez régler le volume en bas à gauche du lecteur média avec l’icône de son.',
            answer_1_subq_3: 'Paramètres système',
            answer_1_suba_3: 'Vérifiez que le son de votre ordinateur n’est pas coupé.',
            question_2: 'J’entends un écho',
            answer_2: 'La diffusion est peut-être ouverte plusieurs fois dans votre navigateur, par exemple dans plusieurs fenêtres ou onglets. Fermez les onglets et fenêtres inutilisés.',
        },
        vision: {
            title: 'Image',
            question_1: 'Le lecteur multimédia affiche uniquement un logo',
            answer_1: 'Ce problème peut être causé par :',
            answer_1_subq_1: 'VPN',
            answer_1_suba_1: 'Si vous utilisez un VPN, il peut bloquer le lecteur multimédia. Désactivez-le temporairement.',
            answer_1_subq_2: 'Citrix',
            answer_1_suba_2: 'Citrix est une application qui simule un environnement informatique via un serveur. Si vous utilisez Citrix, vous devez le désactiver ou vous déconnecter pour voir la diffusion.',
            answer_1_subq_3: 'Bloqueur de publicité',
            answer_1_suba_3: 'Si vous utilisez un bloqueur de publicité, il peut bloquer le lecteur multimédia. Désactivez-le temporairement.',
            answer_1_subq_4: 'Navigateur',
            answer_1_suba_4: 'Vérifiez que votre navigateur est à jour. Les navigateurs plus anciens peuvent ne pas prendre en charge le lecteur multimédia.',
            question_2: 'Le lecteur multimédia affiche un écran noir (avec un code d’erreur)',
            answer_2_part_0: 'Cela peut avoir plusieurs causes :',
            answer_2_part_1: 'Vérifiez si votre navigateur répond aux exigences minimales',
            answer_2_part_2: 'Votre connexion Internet est instable ou trop lente. Vérifiez votre connexion et rechargez la page',
            answer_2_part_3: 'L’environnement réseau dans lequel vous vous trouvez bloque le chargement du lecteur. Contactez votre administrateur réseau',
        },
        network: {
            title: 'Réseau',
            question_1: 'Le signal est pixellisé, saccadé ou met souvent en mémoire tampon',
            answer_1_part_1: 'Le signal peut être perturbé par une connexion Internet lente. Assurez-vous de disposer d’une bande passante suffisante et utilisez de préférence une connexion rapide par Wi-Fi ou câble. Une vitesse de téléchargement minimale de 10 Mbps est recommandée. Vous pouvez vérifier votre vitesse Internet grâce à un ',
            answer_1_part_2: 'https://www.speedtest.net/',
            answer_1_part_3: 'test de vitesse.',
            question_2: 'Puis-je regarder une diffusion depuis un bureau / cabinet / hôpital ?',
            answer_2: 'Pour des raisons de sécurité, de nombreuses entreprises et hôpitaux limitent l’accès aux diffusions en direct. Contactez votre service informatique pour vérifier s’il n’y a pas de restrictions.',
        },
        browsers: {
            title: 'Navigateurs',
            subtitle: 'Vous pouvez suivre la diffusion correctement avec les navigateurs suivants :',
            question_1: 'Version de navigateur recommandée',
            answer_1_part_1: 'Google Chrome 88+',
            answer_1_part_2: 'Mozilla Firefox 85+',
            answer_1_part_3: 'Microsoft Edge 88+',
            answer_1_part_4: 'Apple Safari 14+',
            answer_1_part_5: 'iOS : Safari mobile ou Chrome (iOS14+)',
            answer_1_part_6: 'Android : Chrome 88+',
            question_2: 'Version minimale de navigateur',
            answer_2_part_1: 'Google Chrome 77+',
            answer_2_part_2: 'Mozilla Firefox 68+',
            answer_2_part_3: 'Microsoft Edge 77+',
            answer_2_part_4: 'Apple Safari 12+',
            answer_2_part_5: 'iOS : Safari mobile ou Chrome (iOS10+)',
            answer_2_part_6: 'Android : Chrome 77+',
        },
        system: {
            title: 'Système',
            question_1: 'Spécifications système',
            answer_1_part_1: 'Systèmes d’exploitation minimum :',
            answer_1_part_1_suba_1: 'Windows : 32 ou 64 bits Windows 7 (SP1), Windows 8, Windows 8.1, Windows 10 ou Windows 11',
            answer_1_part_1_suba_2: 'Android : à partir de 8.0 (OREO)',
            answer_1_part_1_suba_3: 'Mac : version OS : Metal requis. macOS X 10.11 (El Capitan)',
            answer_1_part_1_suba_4: 'iOS : à partir de 10',
            answer_1_part_2: 'Systèmes d’exploitation recommandés :',
            answer_1_part_2_suba_1: 'Windows : Windows 10 64 bits',
            answer_1_part_2_suba_2: 'Android : 10',
            answer_1_part_2_suba_3: 'Mac : version OS : Metal requis. macOS X 10.14 (Mojave)',
            answer_1_part_2_suba_4: 'iOS : 12',
        },
    },
    privacyPolicy: {
        title: 'Politique de confidentialité',
        overview: {
            title: 'Général',
            content: 'Dans cette déclaration de confidentialité, vous pouvez lire comment nous traitons vos données personnelles. Vous pouvez avoir confiance que nous le faisons de manière soigneuse. C’est pourquoi nous ne demandons que les données nécessaires pour vous offrir une expérience optimale lors de la diffusion en direct. Nous ne transmettrons jamais vos données à des tiers sans votre consentement.'
        },
        liveBroadcast: {
            title: 'Diffusion en direct',
            content: 'Si vous vous inscrivez et participez à une diffusion en direct, vous donnez votre consentement pour stocker vos données personnelles. Nous le faisons pour permettre l’accès à la diffusion, prévoir le nombre de spectateurs et vous rappeler quand la diffusion commence.',
        },
        cookies: {
            title: 'Cookies',
            content: 'Pour regarder la diffusion en direct, le lecteur vidéo en ligne Motionmakers est utilisé. Ce lecteur utilise des cookies fonctionnels et analytiques. Les cookies fonctionnels sont nécessaires au fonctionnement du lecteur, par exemple pour mémoriser le volume. Les cookies analytiques servent à suivre le nombre de spectateurs et la durée de visionnage.',
        },
        savedData: {
            title: 'Données que nous enregistrons',
            content: 'Nous conservons toutes les données demandées dans le formulaire d’inscription : prénom, nom, adresse e-mail, adresse IP et réponses aux questions ouvertes. De plus, vous pouvez poser des questions par e-mail pendant la diffusion. Ces questions avec l’adresse e-mail correspondante sont également enregistrées.'
        },
        retentionPeriod: {
            title: 'Durée de conservation',
            content: 'Toutes les données sont conservées au maximum 6 mois après la fin de la diffusion en direct. Toutes les informations sont ensuite automatiquement supprimées.'
        },
        dataAccess: {
            title: 'Accès aux données',
            content: 'Les données ne peuvent être consultées que par Motionmakers et le commanditaire de la diffusion. Toutes les données sont stockées en toute sécurité et ne sont pas accessibles à des tiers.'
        },
        contact: {
            title: 'Contact',
            content: 'Pour toute question ou remarque, vous pouvez envoyer un e-mail à <a href="mailto:privacy@motionmakers.nl">privacy@motionmakers.nl</a> ou utiliser les coordonnées ci-dessous :'
        },
        contactAddressLine1: 'Motionmakers',
        contactAddressLine2: 'À l’attention de : Équipe confidentialité',
        contactAddressLine3: 'Frits Spitsstraat 3',
        contactAddressLine4: '1217 WC Hilversum',
        contactAddressLine5: 'Pays-Bas',
        contactAddressLine6: '+31 35 77 33 100',
        contactAddressLine7: 'info@motionmakers.nl'
    },
    termsAndConditions: {
        title: 'Conditions générales',
    },
    security: {
        title: 'Cette page est sécurisée',
        enterPassword: 'Saisissez le mot de passe fourni par l’organisateur.',
        error: 'Le mot de passe saisi est incorrect. Attention : le mot de passe est sensible à la casse.',
        capsLockOn: 'Avertissement : Verr. Maj activé',
        button: 'Regarder',
    },
    singleSession: {
        alreadyWatching: 'Ce lien de visionnage unique est déjà ouvert dans un autre navigateur. Vous n’avez partagé le lien avec personne ? Vérifiez s’il n’est pas déjà ouvert dans une autre fenêtre ou sur un autre appareil.',
    },
    multiSession: {
        selectBreakout: 'Je choisis cette session en sous-groupe',
        changeBreakout: 'Choisir une session en sous-groupe',
        subscribingFor: 'Je veux m’inscrire et je choisis :',
        breakoutRound: 'Session en sous-groupes',
        breakoutRoundValidationText: 'Choisissez une session pour chaque tour de sous-groupes.',
        register: 'S’inscrire',
        ended: 'Terminé',
        now: 'MAINTENANT',
        join: 'PARTICIPER',
        watch: 'REGARDER',
        autoNavigationTitle: 'Cette session est terminée.',
        autoNavigationText: 'Vous serez automatiquement redirigé vers la session suivante {{session}} dans <b>{{countdownSeconds}} secondes</b>.',
        autoNavigationNavigateNowButton: 'Aller à la session suivante',
        sessionWillEndIn: 'Cette session se terminera dans <b>{{countdown}}</b> secondes.',
        sessionWillEndSoon: 'Cette session va bientôt se terminer.',
        breakoutWillEndIn: 'Ce sous-groupe se terminera dans <b>{{countdown}}</b> secondes.',
        breakoutWillEndSoon: 'Ce sous-groupe va bientôt se terminer.',
    },
    calendar: {
        downloaded_text: 'Le fichier du calendrier a été téléchargé. Vérifiez vos téléchargements.',
        click_to_download: 'Cliquez ici pour télécharger à nouveau',
        cta_before_link: 'Cliquez ici pour participer',
        month1: 'janvier',
        month2: 'février',
        month3: 'mars',
        month4: 'avril',
        month5: 'mai',
        month6: 'juin',
        month7: 'juillet',
        month8: 'août',
        month9: 'septembre',
        month10: 'octobre',
        month11: 'novembre',
        month12: 'décembre',
        dayPlaceholder: 'jour',
        monthPlaceholder: 'mois',
        yearPlaceholder: 'année',
    },
    loginPage: {
        welcome: 'Bienvenue',
        loginFormInstruction: 'Si vous vous êtes déjà inscrit, veuillez entrer votre adresse e-mail ci-dessous :',
        emailAddress: 'Adresse e-mail :',
        loginFormSubmitText: 'Connexion',
        registrationLinkInstruction: 'Si vous n’êtes pas encore inscrit à cet événement, veuillez remplir le formulaire d’inscription.',
        registrationButtonText: 'Inscription',
        loginError: 'Aucune inscription trouvée avec cette adresse e-mail. Si vous n’êtes pas encore inscrit, veuillez remplir le formulaire d’inscription.',
    }
};
